import { categoriesService } from "./categories.service";

export const categoryService = {
  getAllCategoryInfo: categoriesService.getAllCategoryInfo,
  updateCategory: categoriesService.updateCategory,
  createCategory: categoriesService.createCategory,
  makeCategoryLive: categoriesService.makeCategoryLive,
};

export type {
  CategoryTreeItem,
  CategoryServiceItem,
  GetAllCategoryInfoResponse,
  UpdateCategoryResponse,
} from "./categories.service";
